import { render, staticRenderFns } from "./BackButtonHeader.vue?vue&type=template&id=2527e2af&"
import script from "./BackButtonHeader.vue?vue&type=script&lang=js&"
export * from "./BackButtonHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports